import React from "react";
import Card from "../UI/Card";
import "./ExpenseItem.css";
import ExpenseItemDate from "./ExpenseItemDate";

const ExpenseItem = (props) => {
  return (
    <li>
      <Card className="expense-item">
        <div>
          <ExpenseItemDate date={props.date} />
        </div>
        <div className="expense-item__description">
          <h2>{props.title}</h2>
          <div className="expense-item__price">R{props.amount}</div>
        </div>
      </Card>
    </li>
  );
};

export default ExpenseItem;
